<template>
  <DialogTemplate
    class="settings-dialog"
    style="max-width: calc(100vw - 2rem)"
    contentStyle="padding:0; margin:0; overflow: hidden;"
  >
    <div class="d-flex">
      <div class="text-large ml-1 pa-4 weight_700 clr-primary">
        {{ $t('links.settings') }}
      </div>

      <!-- <div
        class="gw_banner ml-auto"
        style="--radius: 0; --clr-back: transparent; --padding: 0 2rem"
      >
        <div class="weight_500 clr-white pr-4">
          <div class="text-semi-large">GTO Wizard theme competition</div>
          <div >
            We are giving away
            <span class="clr-primary">10x one month PREMIUM memberships.</span>
          </div>
        </div>
        <div class="f-center ml-auto">
          <a
            target="_blank"
            href="https://forms.gle/QDUzU23kWoxcnJENA/"
            class="gw_btn weight_500 pa-2 clr-white gw_btn_primary"
          >
            {{ $t('btn.read_more') }}
          </a>
        </div>
      </div> -->
    </div>
    <UserSettings class="bt-grey" />
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import UserSettings from '@/components/Dialogs/UserSettingsDialog/UserSettings'

export default {
  name: 'UserSettingsDialog',
  components: {
    UserSettings,
    DialogTemplate,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss">
.settings-dialog {
  min-width: 24rem;
}
.settings-block-title {
  font-size: 1rem;
  font-weight: 500;
  color: var(--clr-grey-3);
  margin: 0 0 0.5rem 0;
  &::first-letter {
    text-transform: capitalize;
  }
}
</style>
